import { render, staticRenderFns } from "./DICarousel.vue?vue&type=template&id=6353e5dc&scoped=true"
import script from "./DICarousel.vue?vue&type=script&lang=js"
export * from "./DICarousel.vue?vue&type=script&lang=js"
import style0 from "./DICarousel.vue?vue&type=style&index=0&id=6353e5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353e5dc",
  null
  
)

export default component.exports